import React from 'react'
import MyToaster from './MyToaster'

const MyToasters = ({ toasts = [] } = {}) => {
  return (
    <div className="fixed top-6 right-6 z-50 flex flex-col gap-3">
      {toasts.map((toast, index) => (
        <MyToaster toast={toast} key={JSON.stringify(toasts[index])} />
      ))}
    </div>
  )
}

export default MyToasters
